import { ROW_TYPES } from './row-type-schedule.model';

export class UpdateRowScheduleModel {
  id: number = null;
  trialBalanceId: number = null;
  accountName: string = null;
  accountNameChange: string = null;
  cyOriginalAmount: number = 0;
  cyOriginalAmountChange: number = 0;
  pyOriginalAmount: number = 0;
  pyOriginalAmountChange: number = 0;
  type: ROW_TYPES = ROW_TYPES.GENERAL;
  isItalic: boolean = false;
  isBold: boolean = false;
  isUnderLine: boolean = false;
  hasBottomLine: boolean = false;
  hasTopLine: boolean = false;
  isHide: boolean = false;
  sortOrder: number = 0;
  isChecked: boolean = false;
  isEdited: boolean = false;
  classNames?: string = '';
  isDeleted: boolean = false;
}
